<div class="greeting-or-period tw-text-navy-500 dark:tw-text-white" *ngIf="countdownData">
	<span *ngIf="countdownData.currentPeriod">{{ countdownData.currentPeriod.long_name }}</span>
	<span *ngIf="countdownData.noActivePeriod && countdownData.nextPeriod">{{ countdownData.nextPeriod.long_name }}</span>
	<div class="countdown">
		<!-- BEFORE SCHOOL -->
		<ng-container
			*ngIf="countdownData.beforeSchool && countdownData.nextPeriod && countdownData.timeUntilNextPeriodStarts < thirtyMinutesInMilliseconds">
			<div class="countdown-period-inactive" *ngIf="countdownData.nextPeriod">in {{ countdownData.timeUntilNextPeriodStarts | countdown }}</div>
		</ng-container>

		<!-- BETWEEN CLASSES -->
		<ng-container *ngIf="!countdownData.beforeSchool && !countdownData.schoolOver && countdownData.noActivePeriod && countdownData.nextPeriod">
			<div class="countdown-period-inactive" *ngIf="countdownData.nextPeriod">in {{ countdownData.timeUntilNextPeriodStarts | countdown }}</div>
		</ng-container>

		<!-- ACTIVE PERIOD, IN CURRENT PERIOD -->
		<ng-container *ngIf="!countdownData.noActivePeriod && countdownData.currentPeriod">
			<div class="countdown-period-active">{{ countdownData.timeUntilCurrentPeriodEnds | countdown }}</div>
		</ng-container>
	</div>
</div>
